export default "__VITE_ASSET__B3US$l4V__"